import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {routing} from './blood-transfusion.routing';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {BloodTransfusionComponent} from './blood-transfusion.component';
import {AutoCompleteModule, DialogModule, MultiSelectModule} from 'primeng/primeng';
import {TrnDischargelistModule} from '../ipd/trn-dischargelist/trn-dischargelist.module';
import {DischargeModule} from '../ipd/discharge/discharge.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CollapseModule, ModalModule} from 'ngx-bootstrap';
import {VacantBedModule} from '../ipd/bed-management/under-maintenance/vacant-bed/vacant-bed.module';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {DischargeSummaryModule} from '../ipd/discharge-summary/discharge-summary.module';
import {LayoutModule} from '../layout/layout.module';
@NgModule ({
    imports: [
        CommonModule, routing, SharedTranslationModule,
        FormsModule,
        HttpModule,
        DialogModule,
        SharedTranslationModule,
        AutoCompleteModule,
        BrowserAnimationsModule,
        MultiSelectModule,
        TrnDischargelistModule,
        LayoutModule,
        DischargeSummaryModule,
        VacantBedModule,
        DischargeModule,
        CollapseModule.forRoot(),
        ModalModule.forRoot()
    ],
    declarations: [BloodTransfusionComponent]
})
export class BloodTransfusionModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/blood-transfusion.module.ts